/* prettier-ignore */

import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cicerone-route-cards',
  templateUrl: './list-routes.component.html',
  styleUrls: ['./list-routes.component.scss']
})

export class ListRoutesComponent {
  @Input() item?: any;
  constructor(public translate: TranslateService) {}
}